import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_TEMPLATE_MUTATION_KEY } from '../../queryKeys';
import { invalidateAllAutomationTemplatesQueries } from '../../queries/useAutomationTemplatesQuery';

export const useDuplicateAutomationTemplateMutation = ({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationKey: AUTOMATION_TEMPLATE_MUTATION_KEY,
		mutationFn: ({
			id,
			name,
			impersonationContext,
		}: {
			id: string;
			name: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(id)}/clone`,
					impersonationContext,
					queryParams: {
						name,
					},
				}),
				'POST'
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllAutomationTemplatesQueries();
			onSuccess?.(data);
		},
	});
};
